import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpContained02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M7.117 10.525a1 1 0 0 0 1.28 1.536l-.64-.768zM12 7.757l.64-.768a1 1 0 0 0-1.28 0zm3.602 4.304a1 1 0 0 0 1.28-1.536l-.64.768zM11 16.243a1 1 0 1 0 2 0h-2m-3.243-4.95.64.768 4.243-3.535-.64-.769-.64-.768-4.243 3.536zM12 7.757l-.64.769 4.243 3.535.64-.768.64-.768-4.243-3.536zm0 0h-1v8.486h2V7.757zm6.788-2.545-.707.707a8.6 8.6 0 0 1 0 12.162l.707.707.707.707c4.14-4.14 4.14-10.85 0-14.99zm0 13.576-.707-.707a8.6 8.6 0 0 1-12.162 0l-.707.707-.707.707c4.14 4.14 10.85 4.14 14.99 0zm-13.576 0 .707-.707a8.6 8.6 0 0 1 0-12.162l-.707-.707-.707-.707c-4.14 4.14-4.14 10.85 0 14.99zm0-13.576.707.707a8.6 8.6 0 0 1 12.162 0l.707-.707.707-.707c-4.14-4.14-10.85-4.14-14.99 0z"
    />
  </svg>
);
export default SvgArrowUpContained02;
